import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, IconButton } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

interface UserData {
  id: string;
  name: string;
  email: string;
  passwordHash: string;
}

const UserList: React.FC = () => {
  const [userList, setUserList] = useState<UserData[]>([]);

  useEffect(() => {
    loadUserList();
  }, []);

  const loadUserList = () => {
    const saved = localStorage.getItem('user-list');
    if (saved) {
      setUserList(JSON.parse(saved));
    }
  };

  const handleDelete = (id: string) => {
    if (!window.confirm('本当にこのユーザーを削除しますか？')) {
      return;
    }

    const updatedList = userList.filter((user) => user.id !== id);
    localStorage.setItem('user-list', JSON.stringify(updatedList));
    setUserList(updatedList);
  };

  const columns: GridColDef[] = [
    { field: 'name', headerName: '名前', flex: 1 },
    { field: 'email', headerName: 'メールアドレス', flex: 1 },
    {
      field: 'actions',
      headerName: '操作',
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => handleDelete(params.row.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
      width: 100,
    },
  ];

  const rows = userList.map((user) => ({ id: user.id, name: user.name, email: user.email }));

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          ユーザー一覧
        </Typography>

        {userList.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10]}
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            登録されたユーザーがいません。
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default UserList;
